export default __webpack_public_path__ + "static/media/cherries.e5647117.PNG";